import {
  FETCH_DB_LOG_HEADERS,
  FETCH_DB_LOG_DETAIL,
} from './types';

import {
  fetchDatabaseLogDetail as fetchDatabaseLogDetailApi,
  fetchDatabaseLogHeaders as fetchDatabaseLogHeadersApi,
} from '../api';

import { fetchActionFactory } from '../../../shared/store/fetchFactory';

export const fetchDatabaseLogHeaders = fetchActionFactory(
  FETCH_DB_LOG_HEADERS,
  fetchDatabaseLogHeadersApi,
  { field: 'dbLogHeaders' }
);

export const fetchDatabaseLogDetail = fetchActionFactory(
  FETCH_DB_LOG_DETAIL,
  fetchDatabaseLogDetailApi,
  { field: 'dbLogDetail' }
);
